<template>
  <div>
    <v-row style="align-items: center">
      <v-col cols="12" md="6" class="py-0 py-sm-1">
        <v-row>
          <v-col
            cols="12"
            v-for="(printer, index) in groupPrinters"
            :key="`printer_${index}`"
            md="6"
            sm="6"
            class="py-0 py-sm-1"
          >
            <v-select
              v-model="printer.printerUrl"
              :ref="`printer_${printer.id}`"
              @change="onChangePrinter($event, printer.id)"
              :items="printers"
              item-text="name"
              item-value="url"
              :label="`Impresora para ${printer.name}`"
              class="mx-sm-3"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col md="6" sm="6" cols="12" class="py-0 py-sm-1">
            <v-select
              v-model="selectedInterval"
              @change="onSelectInterval"
              class="mx-sm-3"
              :items="intervals"
              label="Tipo de gestión de pedidos"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col md="6" sm="6" cols="12" class="py-0 py-sm-1">
            <v-select
              v-model="selectedPrintNum"
              @change="onSelectPrintNum"
              class="mx-sm-3"
              :items="numPrints"
              label="Número de copias a imprimir"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </v-col>
      <v-divider vertical class="vertical-web"></v-divider>
      <v-divider class="mb-line-display"></v-divider>
      <v-col md="5" cols="12" class="py-0 py-sm-1 mt-5 mt-md-0">
        <v-row>
          <v-col lg="8" md="7" sm="12" cols="12" class="py-0 py-sm-1">
            <v-select
              v-model="selectedZone"
              :items="filterZoneItems"
              item-text="name"
              item-value="id"
              label="Filtrar por Zona"
              class="mx-sm-3"
              dense
              outlined
              multiple
            ></v-select>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <template v-for="(printer, index) in groupPrinters">
      <v-alert
        :key="index"
        v-if="!printer.printerUrl"
        type="warning"
        class="mt-3"
        outlined
        prominent
        >{{ printer.printerUrl }}Selecciona una impresora para
        {{ printer.name }}
      </v-alert>
    </template>

    <v-alert v-if="hasOrders" type="info" outlined prominent
      >No hay pedidos en este momento
    </v-alert>

    <div v-for="(ordersGroupeByTableQR, tableQR) in orders" :key="tableQR">
      <div
        v-if="showZoneTable(tableQR)"
        class="section-tableQR-header"
        :style="{ border: `2px solid ${colorsGeneralPrimary}` }"
      >
        <span class="name">Mesa {{ tableQR }}</span>
        <div class="section-button">
          <button
            v-if="!dialogLoader"
            @click="markAllAsDone(tableQR, ordersGroupeByTableQR)"
            class="mark-as-done-button"
            :style="[
              { background: colorsGeneralPrimary },
              { border: `4px solid ${colorsGeneralPrimary}` }
            ]"
          >
            Hecho
          </button>

          <div class="buttons">
            <button
              @click="printOrder(tableQR, ordersGroupeByTableQR)"
              class="print-button"
            >
              <span>Imprimir</span>
            </button>
            <v-btn
              @click="openNotificationDialog(ordersGroupeByTableQR[0])"
              class="notification-button"
              color="transparent"
              dark
            >
              <font-awesome-icon
                icon="paper-plane"
                :style="{ color: '#000000', fontSize: 25 }"
              />
            </v-btn>
          </div>
        </div>
      </div>
      <div v-if="showZoneTable(tableQR)" class="table-scroll">
        <table>
          <thead>
            <tr class="header-row">
              <th class="header-time" :style="{ color: tableHeaderTextTheme }">
                Hora
              </th>
              <th class="header-name" :style="{ color: tableHeaderTextTheme }">
                Pedido
              </th>
              <th class="header-notes" :style="{ color: tableHeaderTextTheme }">
                Notas
              </th>
              <th
                class="header-quantity"
                :style="{ color: tableHeaderTextTheme }"
              >
                Cantidad
              </th>
              <th class="header-table" :style="{ color: tableHeaderTextTheme }">
                Tamaño
              </th>
              <th
                class="header-action"
                :style="{ color: tableHeaderTextTheme }"
              >
                Hecho
              </th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="(orderByTime, time) in ordersGroupByTime(
                ordersGroupeByTableQR
              )"
            >
              <tr
                ref="orderRow"
                v-for="(order, index) in orderByTime"
                :key="`order${time + index}`"
                :style="lastOrders(order.time)"
              >
                <td>
                  <span class="day-format">{{ dayFormatLL(order.time) }}</span>
                  {{ formatTime(order.time) }}
                </td>
                <td>{{ order.name + weight(order) }}</td>
                <td>{{ order.notes }}</td>
                <td class="value-quantity">{{ order.quantity }} x</td>
                <td class="value-table">{{ size(order) }}</td>
                <td class="value-action">
                  <button
                    v-if="order.menu_group_id"
                    @click="markOneProductAsDone(order.menu_group_id)"
                    class="mark-as-done"
                  ></button>
                  <button
                    v-else
                    @click="markOneProductAsDone(order.id)"
                    class="mark-as-done"
                  ></button>
                </td>
              </tr>
              <tr
                class="expandable-row"
                v-if="commentsGrouped[time] && commentsGrouped[time].length"
                :key="time"
              >
                <td colspan="6">
                  <div class="table-cell">
                    <div class="general-notes">Comentarios:</div>
                    <div class="general-desc">
                      {{ commentsGrouped[time][0].comment }}
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <v-dialog v-model="notificationDialog" max-width="350">
      <v-card>
        <v-card-title class="headline">Tiempo de espera</v-card-title>
        <v-card-text>
          <v-select
            :items="items"
            v-model="selectedTime"
            label="Seleccione Hora"
            outlined
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            :disabled="!sendNotification"
            text
            @click="sendNotification"
            >Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Loader :dialog-loader="dialogLoader" message="Procesando pedidos"></Loader>
  </div>
</template>

<script>
import moment from "moment";
import { firestoreTimestamp } from "@/firebaseConfig";
import { drinksCollection } from "@/collections/drinks";
import { foodCollection } from "@/collections/food";
import { qrZoneCollection } from "@/collections/qrZone";
import { printersCollection } from "@/collections/printers";
import Loader from "../../common/Loader";
import printerMixin from "@/mixins/printer/printerMixin";
import { updateOrder } from "@/collections/orders";
import { orderCommentsCollection } from "@/collections/orderComments";
import { qrCollection } from "@/collections/qrs";
import { typeOrdersCollection } from "@/collections/typeOrders";
import { dessertCollection } from "@/collections/dessert";
import { categoriesCollection } from "@/collections/categories";

const PRINT_BY_CATEGORY = "by_category";
const PRINT_BY_PRODUCT = "by_product";

let intervals = [
  {
    text: "Manual",
    value: 0
  },
  {
    text: "Automática cada 15 segundos",
    value: 0.25
  },
  {
    text: "Automática cada 30 segundos",
    value: 0.5
  },
  {
    text: "Automática cada 1 minuto",
    value: 1
  },
  {
    text: "Automática cada 3 minutos",
    value: 3
  },
  {
    text: "Automática cada 5 minutos",
    value: 5
  },
  {
    text: "Automática cada 8 minutos",
    value: 8
  },
  {
    text: "Automática cada 10 minutos",
    value: 10
  },
  {
    text: "Automática cada 15 minutos",
    value: 15
  }
];

let numPrints = [
  {
    text: "1 copia",
    value: 1
  },
  {
    text: "2 copias",
    value: 2
  },
  {
    text: "3 copias",
    value: 3
  },
  {
    text: "4 copias",
    value: 4
  },
  {
    text: "5 copias",
    value: 5
  }
];

let interval = null;

export default {
  name: "Orders-grouped",
  props: {
    orders: Object,
    groupOrderId: String
  },
  mixins: [printerMixin],
  components: { Loader },
  data() {
    return {
      notificationDialog: false,
      selectedOrder: null,
      selectedTime: null,
      items: ["20 min", "30 min", "45 min", "1h", "Más de una 1h"],
      dialogLoader: false,
      printers: [],
      selectedInterval: 0,
      selectedPrintNum: 1,
      intervals: intervals,
      numPrints: numPrints,
      typeOrders: [],
      categories: [],
      orderComments: [],
      dessertCollection: [],
      foodCollection: [],
      drinksCollection: [],
      qrZoneCollection: [],
      selectedZone: ["0"],
      qrCollection: []
    };
  },
  firestore() {
    return {
      orderComments: orderCommentsCollection.orderBy("time", "asc"),
      printers: printersCollection.where("active", "==", true),
      categories: categoriesCollection,
      typeOrders: typeOrdersCollection,
      drinksCollection: drinksCollection,
      foodCollection: foodCollection,
      dessertCollection: dessertCollection,
      qrZoneCollection: qrZoneCollection,
      qrCollection: qrCollection.where("active", "==", true).orderBy("table")
    };
  },
  computed: {
    commentsGrouped() {
      return this.arrayGroupBy(this.orderComments, "time");
    },
    groupPrinters() {
      let printers = [...this.typeOrders].filter(
        x => x.group_order_id === this.groupOrderId
      );
      printers.map(x => {
        let printerUrl = localStorage.getItem(`printer_${x.id}`);
        return (x.printerUrl = printerUrl);
      });
      return printers;
    },
    hasOrders() {
      for (let key in this.orders) {
        if (this.showZoneTable(key)) {
          // eslint-disable-next-line no-prototype-builtins
          if (this.orders.hasOwnProperty(key)) return false;
        }
      }
      return true;
    },
    filterZoneItems() {
      return [{ id: "0", name: "Todos" }, ...this.qrZoneCollection];
    }
  },
  mounted() {
    this.init();
    this.startPrint();
  },
  beforeDestroy() {
    clearInterval(interval);
  },
  methods: {
    weight(order) {
      return order.weight ? " \xa0\xa0" + order.weight + "Kg" : " ";
    },
    init() {
      let selectedInterval = this.$store.state.selectedIntervals[
        this.groupOrderId
      ];
      let selectedPrintNum = this.$store.state.selectedPrintNum[
        this.groupOrderId
      ];
      this.selectedInterval = selectedInterval
        ? selectedInterval
        : this.selectedInterval;
      this.selectedPrintNum = selectedPrintNum
        ? selectedPrintNum
        : this.selectedPrintNum;
    },
    startPrint() {
      let self = this;
      clearInterval(interval);
      if (this.selectedInterval === 0) {
        return;
      }

      interval = setInterval(function() {
        if (Object.keys(self.orders).length) {
          for (const [tableQR, orders] of Object.entries(self.orders)) {
            self.markAllAsDone(tableQR, orders);
          }
        }
      }, this.selectedInterval * 1000 * 60);
    },
    onSelectInterval(value) {
      this.$store.dispatch("setIntervals", {
        [this.groupOrderId]: value
      });

      this.startPrint();
    },
    onSelectPrintNum(value) {
      this.$store.dispatch("setPrintNum", {
        [this.groupOrderId]: value
      });
    },
    async sendNotification() {
      let selectedOrder = { ...this.selectedOrder };
      if (!this.selectedTime || !selectedOrder.length) {
        return;
      }

      let fcmToken = [];
      selectedOrder.forEach(order => {
        if (!fcmToken.includes(order.fcmToken)) {
          fcmToken.push(order.fcmToken);
        }
      });

      try {
        await this.$api.firebase.sendNotification(
          fcmToken,
          this.projectName,
          `Tú pedido de comida para la mesa ${selectedOrder.tableQR} estará listo en ${this.selectedTime}`,
          this.settings.icons.notification
        );
        this.showSuccessMessage("Notificación enviada con éxito!");
      } catch (error) {
        this.showErrorMessage(error.message);
      }
      this.notificationDialog = false;
    },
    openNotificationDialog(order) {
      this.notificationDialog = true;
      this.selectedOrder = order;
    },
    groupBy(array, key) {
      return [...array].reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    lastOrders(time) {
      // Set the currentDate to be 5 minutes ago
      let last5minutesDate = firestoreTimestamp.fromDate(new Date()).toDate();
      last5minutesDate.setMinutes(last5minutesDate.getMinutes() - 5);
      let unixLast5minutesDate = Math.round(last5minutesDate.getTime() / 1000);
      return time.seconds > unixLast5minutesDate ? "font-weight: bold;" : "";
    },
    async markOneProductAsDone(id) {
      try {
        let now = moment().format();
        // eslint-disable-next-line
        console.log(id);

        await updateOrder(id, { isPending: false, orderDoneAt: now });
        this.showSuccessMessage("Se han actualizado los pedidos");
      } catch (error) {
        this.setlogError(
          "update_order",
          "Obtained error message in markOneProductAsDone()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    },
    markAllAsDone(tableQR, ordersGroupeByTableQR) {
      this.dialogLoader = true;

      setTimeout(() => {
        let now = moment().format();
        // eslint-disable-next-line
        console.log("ordersGroupeByTableQR:::::::::::", ordersGroupeByTableQR);
        // update orders
        ordersGroupeByTableQR.forEach(item => {
          let id = item.menu_group_id ? item.menu_group_id : item.id;
          updateOrder(id, {
            isPending: false,
            orderDoneAt: now
          }).catch(error => {
            this.setlogError(
              "update_order",
              "Obtained error message in markAllAsDone()",
              error.stack,
              this.$options.name
            );
          });
        });

        this.printOrder(tableQR, ordersGroupeByTableQR);

        this.showSuccessMessage("Se han actualizado los pedidos");
        this.dialogLoader = false;
      }, 1000);
    },
    size(order) {
      return order.size !== undefined && order.size !== "base"
        ? order.size
        : "";
    },
    ordersGroupByTime(orders) {
      return this.arrayGroupBy(orders, "time");
    },
    async printOrder(tableQR, ordersGroupeByTableQR) {
      if (!this.printersAreActive) {
        this.showErrorMessage("Las impresoras no estan activas");
        return;
      }

      let ifPrintersIsNotSelected = this.groupPrinters.find(
        printer => !printer.printerUrl
      );
      if (ifPrintersIsNotSelected) {
        this.showErrorMessage("No has seleccionado todas las impresoras!");
        return;
      }

      this.groupPrinters.forEach(async printer => {
        if (!printer.printerUrl) {
          return;
        }

        const url = `${printer.printerUrl}&id=${tableQR}`;
        let array = [];
        let comments = [];
        let lastComment = "";
        ordersGroupeByTableQR.forEach(item => {
          if (item.menu_group_id) {
            array.push({
              id: item.id,
              quantity: item.quantity,
              concept: item.order || item.name,
              price: item.price * item.quantity,
              size: item.size,
              notes: item.notes,
              canBeMainCourse: item.canBeMainCourse || false,
              canBeShared: item.canBeShared || false,
              big: this.isBig(item, printer),
              index: item.index
            });
          } else {
            array.push({
              id: item.id,
              quantity: item.quantity,
              concept: item.order || item.name,
              price: item.price * item.quantity,
              size: item.size,
              notes: item.notes,
              canBeMainCourse: item.canBeMainCourse || false,
              canBeShared: item.canBeShared || false,
              big: this.isBig(item, printer)
            });
          }

          if (
            this.commentsGrouped[item.time] !== undefined &&
            lastComment !== this.commentsGrouped[item.time][0].comment &&
            this.commentsGrouped[item.time] &&
            this.commentsGrouped[item.time].length
          ) {
            lastComment = this.commentsGrouped[item.time][0].comment;
            comments.push(lastComment);
          }
        });

        const data = this.buildPrinterData(
          array,
          tableQR,
          comments,
          ordersGroupeByTableQR
        );

        let printerName = "";
        if (printer.name) {
          printerName = printer.name;
        }

        for (let i = 0; i < this.selectedPrintNum; i++) {
          this.postPrinterRequest(url, data, printerName, this.groupOrderId);
        }
      });
    },
    isBig(item, printer) {
      let typeOrderId = null;
      let category = this.getCategory(item);
      if (category && category.printer_mode === PRINT_BY_CATEGORY) {
        typeOrderId =
          category && category.type_order_id !== undefined
            ? category.type_order_id
            : null;
        return typeOrderId ? typeOrderId === printer.id : false;
      }

      let product = this.getProduct(item);
      if (category && category.printer_mode === PRINT_BY_PRODUCT) {
        typeOrderId =
          product && product.type_order_id !== undefined
            ? product.type_order_id
            : null;
        return typeOrderId ? typeOrderId === printer.id : false;
      }

      return false;
    },
    getCategory(item) {
      return this.categories.find(x => x.id === item.category_id);
    },
    getProduct(item) {
      let product;
      if (item.product_type_id === process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID) {
        product = this.drinksCollection.find(
          drink => drink.id === item.product_id
        );
      }

      if (item.product_type_id === process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID) {
        product = this.foodCollection.find(food => food.id === item.product_id);
      }

      if (
        item.product_type_id === process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID
      ) {
        product = this.dessertCollection.find(
          dessert => dessert.id === dessert.product_id
        );
      }

      return product;
    },
    onChangePrinter(value, id) {
      localStorage.setItem(`printer_${id}`, value);
      this.$forceUpdate();
    },
    resetFilters() {
      this.selectedZone = "";
      // eslint-disable-next-line
      console.log("reset filter");
    },
    showZoneTable(table) {
      if (this.selectedZone.some(z => z === "0")) {
        return true;
      }
      let tableQR = this.qrCollection.find(item => item.table === table);
      if (tableQR) {
        let found = this.qrZoneCollection.some(
          x =>
            x.id === tableQR.zone_id &&
            this.selectedZone.some(z => z === x.id) &&
            x.active === true
        );
        if (found) {
          return true;
        }
      }
      return false;
    }
  }
};
</script>

<style scoped lang="scss">
.mb-line-display {
  display: block;
}
@media screen and (min-width: 960px) {
  .vertical-web {
    display: block;
  }
  .mb-line-display {
    display: none;
  }
}
</style>
